import { useEffect } from "react";
import FooterContact from "../../FooterContactPage/FooterContact";
import QuickNav from "../../HomePage/HeroSection/QuickNav";
import ServicesSoftConsulIndusAndFQA from "../../HomePage/Services/ServicesSoftConsulIndusAndFQA";

import SoftConsultingBanner from "../../HomePage/Services/SoftConsultingBanner";
import { ConsultingServices } from "../SoftwareConsulting/ConsultingServices/ConsultingServices";
import { Helmet } from "react-helmet-async";

const Consulting = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const QuickNavItems = ["Services", "Industries", "FAQ", "Form"];
  return (
    <div>
      <Helmet>
        <title>Software Consulting Services | Quad Theory Ltd</title>
        <meta
          name="description"
          content="Quad Theory Ltd offers software consulting services that help teams clarify decisions, review systems, and plan scalable solutions. Practical guidance grounded in real world product and engineering experience."
        />
      </Helmet>
      <SoftConsultingBanner />
      <QuickNav items={QuickNavItems} />
      <ConsultingServices />
      <ServicesSoftConsulIndusAndFQA />
      <FooterContact />
    </div>
  );
};

export default Consulting;
